import { render, staticRenderFns } from "./VInputDefault.vue?vue&type=template&id=1f322b0b&scoped=true&"
import script from "./VInputDefault.vue?vue&type=script&lang=js&"
export * from "./VInputDefault.vue?vue&type=script&lang=js&"
import style0 from "./VInputDefault.vue?vue&type=style&index=0&id=1f322b0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f322b0b",
  null
  
)

export default component.exports